export default {
  data() {
    // Do not modify! These are to be treated as constants.
    return {
      CODE_VERIFIER_KEY: 'cognito-code-verifier',
      STATE_KEY: 'cognito-state'
    };
  },
  methods: {
    getAppClientId(): string {
      const apiKey = getApiKey();
      return process.env.APP_CLIENT_ID[apiKey];
    },
    getRedirectUrl(): string {
      return `${this.getCurrentBaseUrl()}/logged-in`;
    },
    getBaseOauthUrl(): string {
      return `${process.env.COGNITO_URL}/oauth2`;
    },
    getLoginUrl(): string {
      return `${this.getCurrentBaseUrl()}/login`;
    },
    getCurrentBaseUrl(): string {
      return `${window.location.protocol}//${window.location.host}`;
    }
  }
}

function getApiKey(): string{
  const hostname = window.location.host.toString().toUpperCase();
  if(hostname.includes('LOCALHOST')){
    return 'LOCALHOST';
  }
  return hostname.substring(0,hostname.indexOf('.'));
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/mixins/AuthMixin.ts